import { motion } from 'framer-motion';
import { ReactComponent as ClientesIcon } from '../../assets/icons/ClientesIcon.svg';
import { ReactComponent as PhoneIcon } from '../../assets/icons/PhoneIcon.svg';
import { ReactComponent as BirthIcon } from '../../assets/icons/BirthIcon.svg';
import { ReactComponent as MailIcon } from '../../assets/icons/MailIcon.svg';
import { ReactComponent as LocationIcon } from '../../assets/icons/LocationIcon.svg';
import { ReactComponent as EditIcon } from '../../assets/icons/EditIcon.svg';
import { ReactComponent as DeleteIcon } from '../../assets/icons/DeleteIcon.svg';
import { ReactComponent as EventIcon } from '../../assets/icons/EventIcon.svg';
import { ReactComponent as EmpresaIcon } from '../../assets/icons/EmpresaIcon.svg';
import { ReactComponent as LinkIcon } from '../../assets/icons/LinkIcon.svg';

const formatTimestampToDate = (timestamp) => {
if (!timestamp || !timestamp.seconds) {
return 'N/A';
}
const date = new Date(timestamp.seconds * 1000);
const day = String(date.getDate()).padStart(2, '0');
const month = String(date.getMonth() + 1).padStart(2, '0');
const year = date.getFullYear();
return `${day}/${month}/${year}`;
};
const formatDateOfBirth = (dateString) => {
if (!dateString) {
return 'N/A';
}
const [year, month, day] = dateString.split('-');
return `${day}/${month}/${year}`;
};
const ContactDetailsSideBar = ({ contact, onBack, onEdit, onDelete }) => {
return (
<motion.div
initial={{ x: '-100%' }}
animate={{ x: 0 }}
exit={{ x: '-100%' }}
transition={{ duration: 0.15, ease: 'easeInOut' }}
className="contact-details" 
style={{height:'90vh', overflow:'hidden',position:'relative'}}
>
<div className="sidebar-header" style={{padding: '20px 0px 5px'}}>
<div className="sidebar-icon-container">
<button className="back-button" onClick={onBack}>
←
</button>
</div>
<div style={{display:'flex',flexDirection:'row', gap: '10px'}}>
    <div className="sidebar-icon-container">
<EditIcon  onClick={() => onEdit(contact)} className="menu-icon" style={{ height: '15px',margin: 'auto 0', cursor:'pointer' }} />
</div>
  <div className="sidebar-icon-container">
<DeleteIcon  onClick={() => onDelete(contact)} className="menu-icon" style={{ height: '15px',margin: 'auto 0', cursor:'pointer' }} />
</div>
</div>
</div>
<div style={{ textAlign: 'center', margin: '20px 0 25px' }}>
<h3 style={{ margin: '0px', fontFamily: 'Effra', fontWeight: 'normal' }}>
{contact.displayName || 'N/A'}
</h3>
{contact.type !== 'otros' && (
contact.type === 'proveedor' || contact.personeria === 'persona juridica' ? (
<p style={{ margin: '0px', fontFamily: 'Effra', fontWeight: 'normal' }}>
{contact.cuit || 'N/A'}
</p>
) : (
<p style={{ margin: '0px', fontFamily: 'Effra', fontWeight: 'normal' }}>
{contact.numeroDeDocumento || 'N/A'}
</p>
)
)}
</div>

{contact.type === 'proveedor' && (
<div className="contact-details-group">

<div className="contact-details-container" >
<span>Fecha de alta</span>
<div style={{ display: 'flex', flexDirection: 'row', margin: '0', gap: '10px' }}>
<ClientesIcon className="menu-icon" style={{ width: '10px', fill:'#2c2c2c', margin: '0' }} />
<p>{formatTimestampToDate(contact.fechaCreacion)}</p>
</div>
</div>

<div className="contact-details-container" >
<span>Datos de contacto</span>
<div style={{ display: 'flex', flexDirection: 'row', margin: '0', gap: '10px' }}>
<ClientesIcon className="menu-icon" style={{ width: '10px', fill:'#2c2c2c', margin: '0' }} />
<p>{contact.nombreVendedor}</p>
</div>
<div style={{ display: 'flex', flexDirection: 'row', margin: '0', gap: '10px' }}>
<PhoneIcon className="menu-icon" style={{ width: '10px', fill:'#2c2c2c', margin: '0' }} />
<p>{contact.telefono || 'N/A'}</p>
</div>
<div style={{ display: 'flex', flexDirection: 'row', margin: '0', gap: '10px' }}>
<MailIcon className="menu-icon" style={{ width: '10px', fill:'#2c2c2c', margin: '0' }} />
<p>{contact.correoElectronico || 'N/A'}</p>
</div>
{contact.sitioWeb && contact.sitioWeb.trim() !== "" && (
<div style={{ display: 'flex', flexDirection: 'row', margin: '0', gap: '10px' }}>
<LinkIcon className="menu-icon" style={{ width: '10px', fill:'#2c2c2c', margin: '0' }} />
<p>{contact.sitioWeb || 'N/A'}</p>
</div>)}
<div style={{ display: 'flex', flexDirection: 'row', margin: '0', gap: '10px' }}>
<LocationIcon className="menu-icon" style={{ width: '8px', margin: '5px 0 auto 0' }} />
<div style={{ display: 'flex', flexDirection: 'column', margin: '0', gap: '10px' }}>
<p>
{contact.calle} {contact.altura}, {contact.piso} {contact.unidad}
</p>
<p>{contact.codigoPostal}</p>
<p>
{contact.ciudad}, {contact.pais}
</p>
</div>
</div>

</div>
{contact.notas && contact.notas.trim() !== "" && (
<div className="contact-details-container" >
<span>Notas</span>
<div style={{ display: 'flex', flexDirection: 'row', margin: '0', gap: '10px', alignItems:'center' }}>
<EventIcon className="menu-icon" style={{ width: '10px', fill:'#2c2c2c', margin: '0' }} />
<p style={{ whiteSpace: 'pre-wrap', margin: '0 0 0 0' }}>{contact.notas}</p>
</div>
</div>
)}

</div>
)}
{contact.type === 'cliente' && (
<>
{contact.personeria === 'persona fisica' && (
<div className="contact-details-group">
<div className="contact-details-container" >
<span>Fecha de nacimiento</span>
<div style={{ display: 'flex', flexDirection: 'row', margin: '0', gap: '10px' }}>
<BirthIcon className="menu-icon" style={{ width: '10px', fill:'#2c2c2c', margin: '0' }} />
<p>{formatDateOfBirth(contact.fechaDeNacimiento)}</p>
</div>
</div>

<div className="contact-details-container" >
<span>Datos de contacto</span>
<div style={{ display: 'flex', flexDirection: 'row', margin: '0', gap: '10px' }}>
<PhoneIcon className="menu-icon" style={{ width: '10px', fill:'#2c2c2c', margin: '0' }} />
<p>{contact.telefono || 'N/A'}</p>
</div>
<div style={{ display: 'flex', flexDirection: 'row', margin: '0', gap: '10px' }}>
<MailIcon className="menu-icon" style={{ width: '10px', fill:'#2c2c2c', margin: '0' }} />
<p>{contact.correoElectronico || 'N/A'}</p>
</div>
<div style={{ display: 'flex', flexDirection: 'row', margin: '0', gap: '10px' }}>
<LocationIcon className="menu-icon" style={{ width: '8px', margin: '3px 0 auto 0' }} />
<div style={{ display: 'flex', flexDirection: 'column', margin: '0', gap: '10px' }}>
<p>
{contact.calle} {contact.altura}, {contact.piso} {contact.unidad}
</p>
<p>{contact.codigoPostal}</p>
<p>
{contact.ciudad}, {contact.pais}
</p>
</div>
</div>
</div>

<div className="contact-details-container" >
<span>Fecha de alta</span>
<div style={{ display: 'flex', flexDirection: 'row', margin: '0', gap: '10px' }}>
<ClientesIcon className="menu-icon" style={{ width: '10px', fill:'#2c2c2c', margin: '0' }} />
<p>{formatTimestampToDate(contact.fechaCreacion)}</p>
</div>
</div>
{contact.notas && contact.notas.trim() !== "" && (
<div className="contact-details-container" >
<span>Notas</span>
<div style={{ display: 'flex', flexDirection: 'row', margin: '0', gap: '10px', alignItems:'center' }}>
<EventIcon className="menu-icon" style={{ width: '10px', fill:'#2c2c2c', margin: '0' }} />
<p style={{ whiteSpace: 'pre-wrap', margin: '0 0 0 0' }}>{contact.notas}</p>
</div>
</div>
)}
</div>
)}
{contact.personeria === 'persona juridica' && (
<div className="contact-details-group">

<div className="contact-details-container" >
<span>Fecha de alta</span>
<div style={{ display: 'flex', flexDirection: 'row', margin: '0', gap: '10px' }}>
<ClientesIcon className="menu-icon" style={{ width: '10px', fill:'#2c2c2c', margin: '0' }} />
<p>{formatTimestampToDate(contact.fechaCreacion)}</p>
</div>
</div>

<div className="contact-details-container" >
<span>Datos de contacto</span>
{contact.personaDeContacto && contact.personaDeContacto.trim() !== "" && (
<div style={{ display: 'flex', flexDirection: 'row', margin: '0', gap: '10px' }}>
<ClientesIcon className="menu-icon" style={{ width: '10px', fill:'#2c2c2c', margin: '0' }} /> 
<p>{contact.personaDeContacto}</p>
</div>
)}
<div style={{ display: 'flex', flexDirection: 'row', margin: '0', gap: '10px' }}>
<PhoneIcon className="menu-icon" style={{ width: '10px', fill:'#2c2c2c', margin: '0' }} />
<p>{contact.telefono || 'N/A'}</p>
</div>
<div style={{ display: 'flex', flexDirection: 'row', margin: '0', gap: '10px' }}>
<MailIcon className="menu-icon" style={{ width: '10px', fill:'#2c2c2c', margin: '0' }} />
<p>{contact.correoElectronico || 'N/A'}</p>
</div>
<div style={{ display: 'flex', flexDirection: 'row', margin: '0', gap: '10px' }}>
<LocationIcon className="menu-icon" style={{ width: '8px', margin: '3px 0 auto 0' }} />
<div style={{ display: 'flex', flexDirection: 'column', margin: '0', gap: '10px' }}>
<p>
{contact.calle} {contact.altura}, {contact.piso} {contact.unidad}
</p>
<p>{contact.codigoPostal}</p>
<p>
{contact.ciudad}, {contact.pais}
</p>
</div>
</div>
</div>
{contact.notas && contact.notas.trim() !== "" && (
<div className="contact-details-container" >
<span>Notas</span>
<div style={{ display: 'flex', flexDirection: 'row', margin: '0', gap: '10px', alignItems:'center' }}>
<EventIcon className="menu-icon" style={{ width: '10px', fill:'#2c2c2c', margin: '0' }} />
<p style={{ whiteSpace: 'pre-wrap', margin: '0 0 0 0' }}>{contact.notas}</p>
</div>
</div>
)}
</div>
)}
</>
)}
{contact.type === 'otros' && (
<div className="contact-details-group"  style={{overflow:'auto', height:'100%'}}>

{contact.fechaDeNacimiento && contact.fechaDeNacimiento.trim() !== "" && (
<div className="contact-details-container" >
<span>Fecha de nacimiento</span>
<div style={{ display: 'flex', flexDirection: 'row', margin: '0', gap: '10px' }}>
<BirthIcon className="menu-icon" style={{ width: '10px', fill:'#2c2c2c', margin: '0' }} />
<p>{formatDateOfBirth(contact.fechaDeNacimiento)}</p>
</div>
</div>)}
<div className="contact-details-container" >
<span>Datos de contacto</span>
<div style={{ display: 'flex', flexDirection: 'row', margin: '0', gap: '10px' }}>
<PhoneIcon className="menu-icon" style={{ width: '10px', fill:'#2c2c2c', margin: '0' }} />
<p>{contact.telefono || 'N/A'}</p>
</div>
<div style={{ display: 'flex', flexDirection: 'row', margin: '0', gap: '10px' }}>
<MailIcon className="menu-icon" style={{ width: '10px', fill:'#2c2c2c', margin: '0' }} />
<p>{contact.correoElectronico || 'N/A'}</p>
</div>
 {contact.calle && contact.calle.trim() !== "" && (
<div style={{ display: 'flex', flexDirection: 'row', margin: '0', gap: '10px' }}>
<LocationIcon className="menu-icon" style={{ width: '8px', margin: '5px 0 auto 0' }} />
<div style={{ display: 'flex', flexDirection: 'column', margin: '0', gap: '10px' }}>
<p>
{contact.calle} {contact.altura}, {contact.piso} {contact.unidad}
</p>
<p>{contact.codigoPostal}</p>
<p>
{contact.ciudad}, {contact.pais}
</p>
</div>
</div>)}
</div>

{/* Fecha de alta */}
<div className="contact-details-container" >
<span>Fecha de alta</span>
<div style={{ display: 'flex', flexDirection: 'row', margin: '0', gap: '10px' }}>
<ClientesIcon className="menu-icon" style={{ width: '10px', fill:'#2c2c2c', margin: '0' }} />
<p>{formatTimestampToDate(contact.fechaCreacion)}</p>
</div>
</div>


{contact.empresa && contact.empresa.trim() !== "" && (
<div className="contact-details-container" >
<span>Empresa</span>
<div style={{ display: 'flex', flexDirection: 'row', margin: '0', gap: '10px', alignItems:'center' }}>
<EmpresaIcon className="menu-icon" style={{ width: '10px', fill:'#2c2c2c', margin: '0' }} />
<p style={{ whiteSpace: 'pre-wrap', margin: '0 0 0 0' }}>{contact.empresa}</p>
</div>
{contact.sitioWeb && contact.sitioWeb.trim() !== "" && (
<div style={{ display: 'flex', flexDirection: 'row', margin: '0', gap: '10px', alignItems:'center' }}>
<LinkIcon className="menu-icon" style={{ width: '10px', fill:'#2c2c2c', margin: '0' }} />
<p style={{ whiteSpace: 'pre-wrap', margin: '0 0 0 0' }}>{contact.sitioWeb}</p>
</div>)}
</div>
)}
{contact.notas && contact.notas.trim() !== "" && (
<div className="contact-details-container" >
<span>Notas</span>
<div style={{ display: 'flex', flexDirection: 'row', margin: '0', gap: '10px', alignItems:'center' }}>
<EventIcon className="menu-icon" style={{ width: '10px', fill:'#2c2c2c', margin: '0 0 auto' }} />
<p style={{ whiteSpace: 'pre-wrap', margin: '0 0 0 0' }}>{contact.notas}</p>
</div>
</div>
)}

</div>
)}

</motion.div>
);
};
export default ContactDetailsSideBar;